// Some items have a £0.00 base price and the real price comes from the required option picked
// (e.g. 2 Litres / 4 Litres). For those, the menu shows the cheapest option as "From £x".
export function getItemPriceLabel(item) {
  const base = Number(item?.price) || 0;
  if (base > 0) return { text: `£${item.price}`, from: false };

  const optionPrices = (item?.required_options || [])
    .filter((opt) => Number(opt.is_available ?? 1) === 1)
    .map((opt) => Number(opt.option_price) || 0)
    .filter((price) => price > 0);

  if (optionPrices.length === 0) return { text: "", from: false };

  return { text: `£${Math.min(...optionPrices).toFixed(2)}`, from: true };
}
